import DownloadIcon from '@mui/icons-material/Download'
import { Box, Button, Tooltip, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { useWorkingAddress } from '../store/store.hooks'

const DownloadApp = () => {
  const { t } = useTranslation()
  const serverIP = useWorkingAddress()

  const downloadUrl = serverIP ? `http://${serverIP}:50000/PmpTeamMate/PMP%20Solutions.application` : undefined

  return (
    <Box
      sx={{
        padding: 1,
        borderRadius: 1,
        boxShadow: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <Typography variant="subtitle2" component="div">
        {t('downloadApp.title')}
      </Typography>
      <Tooltip title={!serverIP ? t('downloadApp.requiresConnection') : ''} arrow>
        <span style={{ width: '100%' }}>
          <Button
            startIcon={<DownloadIcon />}
            variant="contained"
            color="primary"
            {...(downloadUrl ? { href: downloadUrl, target: '_blank', rel: 'noopener noreferrer' } : {})}
            disabled={!serverIP}
            fullWidth
            sx={{ fontSize: '0.7rem' }}
          >
            {t('downloadApp.downloadButton')}
          </Button>
        </span>
      </Tooltip>
    </Box>
  )
}

export default DownloadApp
